import {Map, type Iterable} from 'immutable';
import type {AuthoringGuideModelV1} from 'resources/GeneratedModels/AuthoringGuide/AuthoringGuideModel.v1';
import type {AuthoringSubjectModelV1} from 'resources/GeneratedModels/AuthoringSubject/AuthoringSubjectModel.v1';

interface UserRelationshipGetters {
  getCanEditGuideLevels(): boolean | null;
  getCanEditQuestions(): boolean | null;
  getCanEditSupplements(): boolean | null;
}

// See note below, this is hysterically temporary
const __withUserRelationshipGetters = function (
  data: Map<string, unknown>
): UserRelationshipGetters {
  return {
    getCanEditGuideLevels(): boolean | null {
      return data.get('can_edit_guide_levels', null) as boolean | null;
    },
    getCanEditQuestions(): boolean | null {
      return data.get('can_edit_questions', null) as boolean | null;
    },
    getCanEditSupplements(): boolean | null {
      return data.get('can_edit_supplements', null) as boolean | null;
    }
  };
};

export const authoringSubjectExtensions = {
  getPracticeGuide(this: AuthoringSubjectModelV1): AuthoringGuideModelV1 {
    return this.getAuthoringGuides().find((guide) => guide.getGuideType() === 'practice');
  },

  /**
   * TODO: 7/18 - determine if this is still a thing
   *
   * TODO: This is a workaround for a busted auto-generated getter.
   *
   * Parsedoc needs to be fixed so that relationship getters are using the
   * name field and not the type. We also need to ensure that the name field
   * is singular and not plural, which we need the model registry to do.
   *
   * We can't do THAT though, until things are babelfied and whatever.
   *
   * instead, we do this workaround by redefining a relationship getter with
   * exactly what we want
   */

  getAuthorRelationships(
    this: AuthoringSubjectModelV1,
    id: string
  ): Iterable<string, UserRelationshipGetters> | UserRelationshipGetters {
    const data = this.getIn(['relationshipMeta', 'author'], Map()) as Map<string, unknown>;
    if (!id) {
      return data.map((rel) => this.__withUserRelationshipGetters(rel));
    } else {
      return __withUserRelationshipGetters(data.get(id, Map()) as Map<string, unknown>);
    }
  }
};
